import { render, staticRenderFns } from "./accountDashboard.vue?vue&type=template&id=0fb3c132&scoped=true"
import script from "./accountDashboard.vue?vue&type=script&lang=js"
export * from "./accountDashboard.vue?vue&type=script&lang=js"
import style0 from "./accountDashboard.vue?vue&type=style&index=0&id=0fb3c132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3c132",
  null
  
)

export default component.exports